import Vue from 'vue'
import VueRouter from "vue-router"
import Login from './Login.vue'
import Home from './Home.vue'
import Fuck from './components/Fuck.vue'
import Member from './components/member/Member'
import Website from './components/website/Website'
import WebsiteAdd from './components/website/WebsiteAdd'
import ProCategory from './components/pro/ProCategory'
import ProCategoryAdd from './components/pro/ProCategoryAdd'
import Pro from './components/pro/Pro'
import ProAdd from './components/pro/ProAdd'
import ProContent from './components/pro/ProContent'
import ImgTag from "@/components/img/ImgTag";
import Img from "@/components/img/Img";
import ImgAdd from "@/components/img/ImgAdd";
import ImgTagAdd from "@/components/img/ImgTagAdd";
import Article from "@/components/article/Article";
import ArticleAdd from "@/components/article/ArticleAdd";
import ArticleTag from "@/components/article/ArticleTag";
import ArticleTagAdd from "@/components/article/ArticleTagAdd";
import ArticleContent from "@/components/article/ArticleContent";
import ArticleBot from "@/components/article/ArticleBot";
import ArticleBotAdd from "@/components/article/ArticleBotAdd";
import UrlRewrite from "@/components/website/UrlRewrite";
import UrlRewriteAdd from "@/components/website/UrlRewriteAdd";
import axios from "axios";
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import {message, Row, Col, Button, Layout, Icon, Menu, Modal, Table, FormModel, Input, Select, Radio, Checkbox, Switch, Upload,Tooltip,Popover, Popconfirm, ConfigProvider, InputNumber, Tag, DatePicker} from "ant-design-vue";

Vue.use(VueRouter)
Vue.use(message).use(Row).use(Col).use(Button).use(Layout).use(Icon).use(Menu).use(Modal).use(Table).use(FormModel).use(Input).use(Select).use(Radio).use(Checkbox).use(Switch).use(Upload).use(Tooltip).use(Popover).use(Popconfirm).use(ConfigProvider).use(InputNumber).use(Tag).use(DatePicker)


Vue.config.productionTip = false
Vue.prototype.$message = message;
Vue.prototype.$ajax = axios;
Vue.prototype.$Modal = Modal;
Vue.prototype.$templatesMap = new Map([
    [1, '默认模板']
]);
Vue.prototype.$loginStatus = false;
Vue.prototype.$host="http://localhost:8888";
switch (process.env.NODE_ENV){
    case 'production':{
        Vue.prototype.$host="http://www.dhw304.com";
        break;
    }
    case 'development':{
        Vue.prototype.$host="http://localhost:8888";
        break;
    }
}
//
// 0. 如果使用模块化机制编程，导入Vue和VueRouter，要调用 Vue.use(VueRouter)

// 1. 定义 (路由) 组件。
// 可以从其他文件 import 进来
const Bar = {template: '<div><h1>上海三个六网络科技有限公司</h1></div>'}

// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。
// 我们晚点再讨论嵌套路由。

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
    routes: [
        // {path: '/', component: Bar, name: 'bar'},
        // {path: '/bar', component: Bar, name: 'bar'},
        {
            path: '/', component: Home, name: 'home',
            redirect: 'admin/home',
            children: [
                {path: 'admin/home', component: Bar, name: 'bar'},
                {path: 'admin/member', component: Member, name: 'member'},
                {path: 'admin/website', component: Website, name: 'website'},
                {path: 'admin/website/add/:website', component: WebsiteAdd, name: 'websiteAdd'},
                {path: 'admin/proCategory', component: ProCategory, name: 'proCategory'},
                {path: 'admin/proCategory/add', component: ProCategoryAdd, name: 'proCategoryAdd'},
                {path: 'admin/pro', component: Pro, name: 'pro'},
                {path: 'admin/pro/add/:product', component: ProAdd, name: 'proAdd'},
                {path: 'admin/pro/content/:product', component: ProContent, name: 'proContent'},
                {path: 'admin/img', component: Img, name: 'img'},
                {path: 'admin/img/add/:img', component: ImgAdd, name: 'imgAdd'},
                {path: 'admin/imgTag', component: ImgTag, name: 'imgTag'},
                {path: 'admin/imgTag/add', component: ImgTagAdd, name: 'imgTagAdd'},
                {path: 'admin/article', component: Article, name: 'article'},
                {path: 'admin/article/add/:article', component: ArticleAdd, name: 'articleAdd'},
                {path: 'admin/articleTag', component: ArticleTag, name: 'articleTag'},
                {path: 'admin/articleTag/add', component: ArticleTagAdd, name: 'articleTagAdd'},
                {path: 'admin/articleContent/:article', component: ArticleContent, name: 'articleContent'},
                {path: 'admin/articleBot', component: ArticleBot, name: 'articleBot'},
                {path: 'admin/articleBot/add/:articleBotTask', component: ArticleBotAdd, name: 'articleBotAdd'},
                {path: 'admin/urlRewrite', component: UrlRewrite, name: 'urlRewrite'},
                {path: 'admin/urlRewrite/add/:urlRewrite', component: UrlRewriteAdd, name: 'urlRewriteAdd'},
            ]
        },
        {path: '/login', component: Login, name: 'login'},
        {path: '/fuck', component: Fuck, name: 'fuck'},
    ]
})

router.beforeEach((to, from, next) => {
    if (to.name !== 'login' && localStorage.getItem("token") == null) {
        next({name: 'login'})
    } else next()
})



function showConfirm() {
    if(Vue.prototype.$loginStatus===true){
        return
    }
    Modal.confirm({
        title: '登录已经过期',
        content: '点击确定重新登录，点击取消仍留在当前页面',
        okText: '重新登录',
        okType: 'danger',
        cancelText: '暂不登录',
        onOk() {
            Vue.prototype.$loginStatus = false;
            localStorage.removeItem("token");
            localStorage.setItem("loginFrom",window.location.href);
            router.push({path: "/login"});
        },
        onCancel() {
            Vue.prototype.$loginStatus = false;
        },
    });
    Vue.prototype.$loginStatus = true;
}

axios.interceptors.request.use(
    function (config) {
        let token = localStorage.getItem("token");
        if (token != null) {
            config.headers.adminToken = token;
        }
        // console.log("========请求前置拦截==========" + token)
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    function (config) {
        // 对响应数据做点什么
        if (config.status === 200) {
            switch (config.data.code) {
                case -1001: {
                    showConfirm();
                    break;
                }
                case 200: {
                    break;
                }
                default: {
                    console.log("无法识别的Code：" + config.data.code)
                }
            }
        }
        return config;
    },
    function (error) {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

new Vue({
    router,
    comments:{
        ConfigProvider
    },
    data: function () {
        return {
            locale: zhCN,
        }
    }
}).$mount('#app')